export default __webpack_public_path__ + "static/media/user_image_2.60da55cc.jpg";